import React, { useMemo } from 'react';
import ReactApexChart from 'react-apexcharts';
import { getApexTheme } from '@/lib/apex-theme';

interface ApexAreaChartProps {
  height?: number;
  series: Array<{
    name: string;
    data: number[];
  }>;
  categories: string[];
  formatter?: (value: number) => string;
}

export const ApexAreaChart: React.FC<ApexAreaChartProps> = ({ 
  height = 300, 
  series, 
  categories,
  formatter = (val) => val.toFixed(1)
}) => {
  const options = useMemo(() => {
    const theme = getApexTheme();
    
    return {
      ...theme,
      chart: {
        ...theme.chart,
        type: 'area' as const,
        height,
        animations: {
          enabled: true,
          easing: 'easeinout',
          speed: 300
        }
      },
      xaxis: {
        ...theme.xaxis,
        categories,
        tooltip: {
          enabled: false
        }
      },
      fill: {
        type: 'gradient',
        gradient: {
          shadeIntensity: 1,
          opacityFrom: 0.7,
          opacityTo: 0.2,
          stops: [0, 90, 100]
        }
      },
      tooltip: {
        ...theme.tooltip,
        y: {
          formatter
        }
      }
    };
  }, [height, categories, formatter]);

  return <ReactApexChart options={options} series={series} type="area" height={height} />;
};
